export default __webpack_public_path__ + "static/media/watertorenKlein.79ac3eab.jpg";